module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "overlay"
  }, [_h('div', {
    staticClass: "overlay-content"
  }, [_h('a', {
    staticClass: "overlay-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": back
    }
  }, ["✕"]), " ", _m(0)])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "overlay-inner"
  }, [_h('h2', ["Start-up Innovation"]), " ", _h('p', [_h('span', {
    staticClass: "versa"
  }, ["Start-ups"]), " can be a very efficient way to transform ideas or technology into marketable products or life saving innovation when thinking about the protection of our environment. ", _h('span', {
    staticClass: "versa"
  }, ["Corporations"]), " often lack the ability to\n        innovate and change fundamentally whereas start-ups can quickly adopt new approaches, mindsets and\n        requirements from a globalized world. One of these requirements is to live in harmony with our ", _h('span', {
    staticClass: "versa"
  }, ["Environment"]), "\n        whilst at the same time maintaining our standards of living. ", _h('span', {
    staticClass: "versa"
  }, ["Technology"]), " and ", _h('span', {
    staticClass: "versa"
  }, ["Start-ups"]), " can help overcome the\n        current gap."]), " ", _h('p', ["Therefore we support the development of ", _h('span', {
    staticClass: "versa"
  }, ["Cleantech"]), " start-ups in many ways:"]), " ", _h('ul', [_h('li', ["Mentoring"]), " ", _h('li', ["Business Modelling"]), " ", _h('li', ["Financing"]), " ", _h('li', ["Energy Regulation"])]), " ", _h('h2', ["START-UP accelerator & contest activity"]), " ", _h('ul', {
    staticClass: "years"
  }, [_h('li', [_h('span', ["2013-2015"]), "Organization support & ", _h('a', {
    attrs: {
      "href": "//www.youtube.com/user/StartupNightBerlin/feed?activity_view=1",
      "target": "_blank"
    }
  }, ["moderation"]), " Start-up Night Berlin (", _h('a', {
    attrs: {
      "href": "//www.startupnight.de/"
    }
  }, ["Lange Nacht der Startups"]), ")\n        "]), " ", _h('li', [_h('span', ["2015"]), "Jury member ", _h('a', {
    attrs: {
      "href": "//www.incense-accelerator.com/",
      "target": "_blank"
    }
  }, ["INCENSe"]), " Accelerator"]), " ", _h('li', [_h('span', ["2015"]), "Jury member and mentor ", _h('a', {
    attrs: {
      "href": "//www.climate-kic.org/national-centres/berlin-germany/green-garage/",
      "target": "_blank"
    }
  }, ["Climate KIC Green Garage Accelerator"])]), " ", _h('li', [_h('span', ["2015"]), "Mentor ", _h('a', {
    attrs: {
      "href": "//cleantech-innovationcenter.de/",
      "target": "_blank"
    }
  }, ["Clean Tech Innovation Center"])]), " ", _h('li', [_h('span', ["2014"]), "Jury member ", _h('a', {
    attrs: {
      "href": "//www.eitdigital.eu/idea-challenge/about/",
      "target": "_blank"
    }
  }, ["EIT Digital Idea Challenge"]), " Smart Energy Systems"]), " ", _h('li', [_h('span', ["2013"]), "Jury member ", _h('a', {
    attrs: {
      "href": "//www.telekom-innovation-contest.com/",
      "target": "_blank"
    }
  }, ["Telekom Innovation Contest Smart Energy Systems"])])]), " ", _h('p', {
    staticClass: "end"
  })])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-721fa162!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Startup.vue
// module id = 38
// module chunks = 1